import { ValueSaveRequestDto } from '../dto/request/value-save-request.dto';
import { ValueUpdateRequestDto } from '../dto/request/value-update-request.dto';
import { ValueResponseDto } from '../dto/response/value-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class ContributionService extends BaseLandscapeService {
  public async fetchContributionById(id: string): Promise<ValueResponseDto> {
    const response = await this.get<ValueResponseDto>(`/contribution/${id}`);
    return response.data;
  }

  public async saveContribution(
    saveRequest: ValueSaveRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.post<ValueResponseDto>(
      `/contribution`,
      saveRequest
    );
    return response.data;
  }

  public async updateContribution(
    updateRequest: ValueUpdateRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.put<ValueResponseDto>(
      `/contribution`,
      updateRequest
    );
    return response.data;
  }

  public async updateVerificationLabel(
    updateRequest: ValueUpdateRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.put<ValueResponseDto>(
      `/contribution/putverificationlabel`,
      updateRequest
    );
    return response.data;
  }

  public async deleteContribution(existingId: string): Promise<void> {
    await this.delete<void>(`/contribution/${existingId}`);
  }
}

const contributionService = new ContributionService();
export default contributionService;
